module.exports = {
  /**
   * 获取cookie值
   * @param {string} key 入参
   */
  getCookie(key) {
    const cookie_str = document.cookie;
    const cookie_arr = cookie_str.split('; ');
    const cookie_obj = {};
    cookie_arr.map((item)=>{
      const kv = item.split('=');
      cookie_obj[kv[0]] = kv[1];
      return item;
    });

    return key ? cookie_obj[key] : cookie_obj;
  },

  /**
   * 设置cookie
   * @param {string} key 设置cookie的key
   * @param {any} value cookie的值
   * @param {number} second 过期时间，单位s
   */
  setCookie(key, value, second){
    let expires = "";
    if (second) {
      var date = new Date();
      date.setTime(date.getTime() + (second * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = key + "=" + (value || "")  + expires + "; path=/";
  }
}


// WEBPACK FOOTER //
// ./src/base/cookie.js